import React, { useState } from "react";
import { render } from "react-dom";

import {
  ButtonBase,
  Box,
  CssBaseline,
  ThemeProvider,
  Typography
} from "@material-ui/core";

import authoringTheme from "./theme/authoringTheme";
import { CheckBox, CheckBoxOutlineBlank } from "@material-ui/icons";
import { NavItem } from "./components/navitem";

import svgLoader from "../utils/svgLoader";

import logoStudioComponent from "./components/assets/logo-studio.svg";
import logoDashboardComponent from "./components/assets/logo-dashboard.svg";
import logoPortalComponent from "./components/assets/logo-portal.svg";

import { useTheme } from "@material-ui/core/styles";

const Title = () => {
  return (
    <Typography
      variant="h1"
      style={{
        textAlign: "center",
        top: "calc(25% - 64px)",
        left: "50%",
        width: "100%",
        translate: "-50% -50%",
        position: "absolute",
        fontWeight: "normal",
        fontSize: 36,
        padding: "0 24px",
        letterSpacing: 4
      }}>
      <nobr>
        Where would you <wbr />
        like to go?
      </nobr>
    </Typography>
  );
};

const DestinationBox = ({ remember, name, path, description, image }) => {
  const theme = useTheme();
  return (
    <ButtonBase
      alignItems="left"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        width: 152,
        boxSizing: "content-box",
        padding: theme.spacing(6),
        borderRadius: theme.shape.borderRadius * 2,
        gap: theme.spacing(4),
        textAlign: "center"
      }}
      onClick={() => {
        if (remember) {
          try {
            window.localStorage.setItem("REMEMBER_LANDINGPAGE_CHOICE", path);
          } catch (e) {}
        }
        const url = new URL(window.location.href);
        url.pathname = path;
        window.location.href = url.href;
      }}>
      <img src={image} alt="" />

      <Typography variant="h4">
        <b>{name}</b>
      </Typography>

      <Typography>{description}</Typography>
    </ButtonBase>
  );
};

const Destinations = ({ remember }) => {
  const logoDashboard = svgLoader(logoDashboardComponent);
  const logoPortal = svgLoader(logoPortalComponent);
  const logoStudio = svgLoader(logoStudioComponent);
  const theme = useTheme();
  return (
    <Box
      style={{
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        height: "300px",
        left: "0",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        gap: theme.spacing(4)
      }}>
      <DestinationBox
        name="Portal"
        path="/portal/"
        description="Manage your simulations, create/edit in Studio."
        image={logoPortal}
        remember={remember}
      />
      <DestinationBox
        name="Dashboard"
        path="/dashboard/"
        description="Create sessions, add users and more."
        image={logoDashboard}
        remember={remember}
      />
    </Box>
  );
};

const Footer = ({ remember, setRemember }) => {
  return (
    <>
      <Box position="absolute" bottom={0} display="flex" width={1} p={2}>
        <NavItem
          startIcon={remember ? <CheckBox /> : <CheckBoxOutlineBlank />}
          onClick={e => {
            e.stopPropagation();
            setRemember(!remember);
          }}>
          Remember my choice
        </NavItem>
        <Box flexGrow={1} />
      </Box>
    </>
  );
};

const AppWrapper = () => {
  const [remember, setRemember] = useState(false);
  return (
    <>
      <ThemeProvider theme={authoringTheme}>
        <CssBaseline />
        <Box overflow="auto" display="flex" flexDirection="column">
          <Box
            style={{
              position: "absolute",
              top: "0",
              height: "100vh",
              width: "100%"
            }}>
            <Title />
            <Destinations remember={remember} />
            <Footer remember={remember} setRemember={setRemember} />
          </Box>
        </Box>
      </ThemeProvider>
    </>
  );
};

try {
  const choice = window.localStorage.getItem("REMEMBER_LANDINGPAGE_CHOICE");
  if (choice) {
    const url = new URL(window.location.href);
    url.pathname = choice;
    window.location.href = url.href;
  }
} catch (e) {}

// Uncomment this if you need to use css files
// Immediately load the css bundle
/*const url = new URL(window.location.href);
const urlParamName = "landingBundlePath";
const bundlePath =
  url.searchParams.get(urlParamName) || window.trcAppSettings[urlParamName] || "https://cdn.regis-co.com/landing/v1.x.x/";
const bundlePathUrl = new URL(bundlePath);
if (bundlePathUrl.pathname.charAt(bundlePathUrl.pathname.length - 1) !== "/") {
  bundlePathUrl.pathname += "/";
}
window.loadScript(`${bundlePathUrl.href}bundle.css`);*/

// Render the app
render(<AppWrapper />, document.getElementById("app"));
